import React from 'react';
import { IonCard, IonCardContent } from '@ionic/react';

interface Props {
  title: string;
  value: string | number;
  color?: string;
}

const StatsCard: React.FC<Props> = ({ title, value, color = '#3880ff' }) => {
  return (
    <IonCard style={{ textAlign: 'center' }}>
      <IonCardContent>
        <div style={{ fontSize: 28, fontWeight: 'bold', color }}>{value}</div>
        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{title}</div>
      </IonCardContent>
    </IonCard>
  );
};

export default StatsCard;
